import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'user-authorisations-desktop',
    templateUrl: './authorisations-desktop.component.html',
    styleUrls: ['./../authorisations.component.scss', './authorisations-desktop.component.scss'],
    standalone: false
})
export class AuthorisationsDecktopComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
